<template>
  <div class="wrap">
    <header class="header">
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>矿机商城</h2>
      <span @click="myKuang">我的矿机</span>
    </header>
    <div class="main">
      <div class="list" v-for="i in 3" :key="i" @click="lookDetail()">
        <p class="title">Ant miner S21 Pro</p>
        <p>单笔限额：50000.00~99999.00</p>
        <p>日收益率：2.50%</p>
        <p>锁仓天数：60天</p>
        <p>
          <span class="progress"><mt-progress :value="20" :bar-height="5"><div slot="end">20%</div></mt-progress></span>
          <span class="btn">锁仓</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import {
		mapState
	} from 'vuex'
  export default {
    data() {
      return {
        
      }
    },
    computed: {
			...mapState(['lang'])
		},
    mounted() {
      
    },
    methods:{
      goBack() {
        this.$router.go(-1)
      },
      lookDetail(){
        this.$router.push('WakuangInfo')
      },
      myKuang(){
        this.$router.push('MyWakuang')
      }
    }
  }
</script>
<style  scoped>
  .main{
    background: #f5f5f5;

    .list{
      margin:12px;
      background: #fff;
      padding:12px;
      border-radius: 8px;
      p{
        line-height: 24px;
        color:#333;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.title{
          font-size: 16px;
          font-weight: bold;
        }
        .progress{
          flex:1;
        }
        .btn{
          margin-left:30px;
          padding:2px 10px;
          background: #F56867;
          color:#fff;
          border-radius: 5px;

          &.grey{
            background: #8a8a8a;
          }

          &.green{
            background: #03ad90;
          }
        }
      }
    }
  }
</style>